export default function Footer() {
  const currentYear = new Date().getFullYear();

  const linkGroups = [
    {
      title: '综艺分类',
      links: ['热门综艺', '搞笑综艺', '真人秀', '音乐节目', '脱口秀', '竞技综艺'],
    },
    {
      title: '关于我们',
      links: ['平台介绍', '内容来源', '版权声明', '用户协议', '隐私政策'],
    },
    {
      title: '帮助中心',
      links: ['常见问题', '播放帮助', '画质说明', '问题反馈', '意见建议'],
    },
    {
      title: '合作伙伴',
      links: [],
      isPartner: true,
    },
  ];

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-300/30">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          {linkGroups.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading font-semibold text-foreground-200 text-sm mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.isPartner ? (
                  <li className="text-xs text-foreground-500">虚位以待</li>
                ) : (
                  group.links.map((link) => (
                    <li key={link}>
                      <a
                        href="#footer"
                        onClick={(e) => e.preventDefault()}
                        className="text-xs text-foreground-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                      >
                        {link}
                      </a>
                    </li>
                  ))
                )}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-300/20 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <span className="font-heading font-bold text-primary-400 text-lg">6080影视</span>
            <span className="text-xs text-foreground-600">— 综艺节目高清免费在线观看</span>
          </div>

          <p className="text-xs text-foreground-600">
            &copy; {currentYear} 6080影视。本站内容仅供交流学习，请在24小时内删除。
          </p>

          <div className="flex items-center gap-3">
            <span className="text-xs text-foreground-600">关注我们</span>
            <a href="#footer" onClick={(e) => e.preventDefault()} className="w-7 h-7 flex items-center justify-center text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-base"></i>
            </a>
            <a href="#footer" onClick={(e) => e.preventDefault()} className="w-7 h-7 flex items-center justify-center text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-base"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}